import React from 'react';
import { isEmpty } from 'lodash';
import countryCodes from '../components/mobileInput/countryCodeData';
import renderEmail from "./renderers/renderEmail";
import renderFirstName from "./renderers/renderFirstName";
import renderLastName from "./renderers/renderLastName";
import renderMobile from './renderers/renderMobile';
import renderGender from './renderers/renderGender';
import renderAgeGroup from './renderers/renderAgeGroup';
import renderCountry from './renderers/renderCountry';
import renderZip from './renderers/renderZip';
import renderBirthDate from './renderers/renderBirthDate';
import renderParentalConsent from './renderers/renderParentalConsent';

import renderCustomDropdown from './renderers/renderCustomDropdown';
import renderCustomDate from './renderers/renderCustomDate';
import renderCustomText from './renderers/renderCustomText';
import renderCustomParentConsent from './renderers/renderCustomParentConsent';
import renderOptin from './renderers/renderOptin';
import renderParentEmail from './renderers/renderParentEmail';

export function getDataFromCountryCode (code) {
    let countryData = {...countryCodes[2]};
    for (let i = 0; i < countryCodes.length; i++) {
        const d = countryCodes[i];
        if (code.toLowerCase() === d.iso2.toLowerCase()) {
            countryData = {
            codeIndex: i, // is the index selected
            country: d.iso2, // country is the au, us, uk , etc...
            phoneCountry: d.iso2, // country is the au, us, uk , etc...
            countryCode: d.code, // number string
        };
        break;
      }
    }
    return countryData;
}

// 1 is required, 2 is not required , 0 no field
function render (params) {
    return (<React.Fragment>
        { renderEmail(params) }
        { renderFirstName(params) }
        { renderLastName(params) }
        { renderMobile(params) }
        { renderGender(params) }
        { renderAgeGroup(params) }
        { renderCountry(params) }
        { renderZip(params) }
        { renderBirthDate(params)}
        { renderParentalConsent(params) }
        { renderParentEmail(params) }
    </React.Fragment>);
}

const componentsRenderers = {
    text:  renderCustomText,
    dropdown: renderCustomDropdown,
    datepicker: renderCustomDate,
    parentalconsent: renderCustomParentConsent,
};

function renderCustomFields (params) {
   
    if (!isEmpty(params.customFields)) {
        return (<React.Fragment>
            {
                 params.customFields.map((item, i) => {
                    const renderFunc = componentsRenderers[item.type];
                    if (item.visible && typeof renderFunc === 'function') {
                        return renderFunc({
                            ...params,
                            item,
                            key: `custom-field-${i}`
                        });
                    }
                    return null;
                 })
            }
        </React.Fragment>);
    }
    return (<React.Fragment></React.Fragment>);
}

function renderOptins (params) {
    if (!isEmpty(params.optins)) {
        return (<React.Fragment>
            {
                 params.optins.map((optin, i) => { 
                    return renderOptin({
                        key: `optin-${i}`,
                        ...params,
                        optin,
                    }); 
                 })
            }
        </React.Fragment>);
    }
    return (<React.Fragment></React.Fragment>);
}


const fieldsFactory = {
    render,
    renderCustomFields,
    renderOptins,
};

export default fieldsFactory;
